// covered-by: frontends/carrie/src/ask-v2/services/__tests__/briefing.test.ts
import {
  type AskPunttActionResolution,
  type AskPunttBriefing,
  dismissAskPunttBriefingResponseSchema,
  getAskPunttBriefingLogResponseSchema,
  getAskPunttBriefingResponseSchema,
  patchAskPunttBriefingMemoryResponseSchema,
  resolveAskPunttBriefingActionResponseSchema,
  type GetAskPunttBriefingLogResponse,
  type PatchAskPunttBriefingMemoryResponse,
  type ResolveAskPunttBriefingActionResponse,
} from "@mg/schemas/src/christo/askPunttBriefing";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

export const ASK_V2_BRIEFING_QUERY_KEY = ["ask-v2", "briefing"] as const;

const briefingUrl = `${API_URL}/private/catalyst/ask-puntt/briefing`;

export async function getBriefing(): Promise<AskPunttBriefing> {
  const json = await smartFetch(briefingUrl, { method: "GET" });
  return getAskPunttBriefingResponseSchema.parse(json);
}

export async function getBriefingLog(): Promise<GetAskPunttBriefingLogResponse> {
  const json = await smartFetch(`${briefingUrl}/log`, { method: "GET" });
  return getAskPunttBriefingLogResponseSchema.parse(json);
}

export async function resolveBriefingAction(
  actionId: string,
  resolution: AskPunttActionResolution,
  note?: string,
): Promise<ResolveAskPunttBriefingActionResponse> {
  const json = await smartFetch(`${briefingUrl}/actions/${actionId}/resolve`, {
    method: "POST",
    body: JSON.stringify({ resolution, note }),
  });
  return resolveAskPunttBriefingActionResponseSchema.parse(json);
}

export async function patchBriefingMemory(
  id: string,
  text: string,
): Promise<PatchAskPunttBriefingMemoryResponse> {
  const json = await smartFetch(`${briefingUrl}/memory/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ text }),
  });
  return patchAskPunttBriefingMemoryResponseSchema.parse(json);
}

export async function dismissBriefing(): Promise<AskPunttBriefing> {
  const json = await smartFetch(`${briefingUrl}/dismiss`, {
    method: "POST",
    body: JSON.stringify({}),
  });
  return dismissAskPunttBriefingResponseSchema.parse(json).briefing;
}
